import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  Input,
  OnInit,
  ViewChild,
  ViewEncapsulation,
} from "@angular/core";
import { Observable } from "rxjs";
import { getBackgroundImageStyles } from "src/app/shared/functions/ng-style-utils";
import type { Swiper } from "swiper";
import { contentListItem } from "../util";

const BREAKPOINTS = [
  { sliderSize: 4, minWidth: 1200, maxWidth: 99999 },
  { sliderSize: 3, minWidth: 900, maxWidth: 1200 },
  { sliderSize: 2, minWidth: 600, maxWidth: 900 },
  { sliderSize: 1, minWidth: 0, maxWidth: 600 },
];

@Component({
    selector: "app-vertical-scroll",
    templateUrl: "./vertical-scroll.component.html",
    styleUrls: ["./vertical-scroll.component.scss"],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class VerticalScrollComponent {
  @Input() items: Observable<contentListItem[]>;
  swiper: Swiper;

  constructor(private cdr: ChangeDetectorRef) {}

  slidesPerView() {
    let elWidth = (this.swiper?.el as HTMLElement)?.clientWidth ?? 0;

    return BREAKPOINTS.find(
      (bkpt) => bkpt.minWidth <= elWidth && bkpt.maxWidth > elWidth
    ).sliderSize;
  }
  onSwiper(ev: CustomEvent) {
    this.swiper = ev.detail[0];
    this.swiper.on("slideChange", () => this.cdr.detectChanges());
  }
  navigateTo(i: number) {
    this.swiper.slideTo(i);
  }
  getImgStyle(url) {
    return url?.length > 0
      ? getBackgroundImageStyles(0, url)
      : { background: "#ddd" };
  }
}
